class Store {
    constructor() {
        this.activeroute = undefined;
        this.initalroute = undefined;
    }
    hasActiveHash() {
        const ahash = window.location.hash.replace("#", '');
        return ahash ? true : false;
    }
    getActiveRoute() {
        return this.activeroute;
    }
    setActiveLetr(id, isHome = false) {
        this.activeroute = {
            letrid: id,
            objectid: '',
            tab: isHome ? "Home" : "Document",
            schemaid: '',
            noteid: '',
            datasheetid: '',
            rowid: ''
        };
        console.log('this.activeroute');
        console.log(this.activeroute);
        this.updateUrlHash();
    }
    setActveObject(id) {
        if (this.activeroute) {
            this.activeroute.objectid = id;
            this.activeroute.tab = "Document";
            this.updateUrlHash();
        }
    }
    setActiveHome() {
        if (this.activeroute) {
            this.activeroute.tab = "Home";
            this.updateUrlHash();
        }
    }
    setActiveDatasheet(id) {
        if (this.activeroute) {
            this.activeroute.datasheetid = id;
            this.activeroute.tab = "Datasheet";
            this.updateUrlHash();
        }
    }
    setActiveNote(id) {
        if (this.activeroute) {
            this.activeroute.noteid = id;
            this.updateUrlHash();
        }
    }
    clearAdminView() {
        if (this.activeroute) {
            this.activeroute.tab = "Document";
            this.updateUrlHash();
        }
    }
    setActiveSchemaid(id) {
        if (this.activeroute) {
            this.activeroute.schemaid = id;
            this.updateUrlHash();
        }
    }
    setActiveRowid(id) {
        if (this.activeroute) {
            this.activeroute.rowid = id;
            this.updateUrlHash();
        }
    }
    setAdminView() {
        this.activeroute = {
            letrid: "",
            objectid: '',
            tab: "Admin",
            schemaid: '',
            noteid: '',
            datasheetid: '',
            rowid: ''
        };
        this.updateUrlHash();
    }
    setContactView() {
        this.activeroute = {
            letrid: "",
            objectid: '',
            tab: "Contacts",
            schemaid: '',
            noteid: '',
            datasheetid: '',
            rowid: ''
        };
        this.updateUrlHash();
    }
    setDevicesView() {
        this.activeroute = {
            letrid: "",
            objectid: '',
            tab: "Devices",
            schemaid: '',
            noteid: '',
            datasheetid: '',
            rowid: ''
        };
        this.updateUrlHash();
    }
    setSearchView() {
        this.activeroute = {
            letrid: "",
            objectid: '',
            tab: "Search",
            schemaid: '',
            noteid: '',
            datasheetid: '',
            rowid: ''
        };
        this.updateUrlHash();
    }
    parseUrlHash() {
        const hash = window.location.hash.replace("#", '');
        if (hash) {
            const activeroute = {
                letrid: "",
                objectid: '',
                tab: "Home",
                schemaid: '',
                noteid: '',
                datasheetid: '',
                rowid: ''
            };
            const parts = hash.split("~~");
            activeroute.letrid = parts[0];
            if (parts.length > 1) {
                const tab = parts[1];
                if (tab === 'Doc') {
                    activeroute.tab = "Document";
                }
                else if (tab === "Datasheet") {
                    activeroute.tab = "Datasheet";
                }
                else if (tab == "Admin") {
                    activeroute.tab = "Admin";
                    activeroute.letrid = "";
                }
                else if (tab === "Devices") {
                    activeroute.tab = "Devices";
                    activeroute.letrid = "";
                }
                else if (tab === "Contacts") {
                    activeroute.tab = "Contacts";
                    activeroute.letrid = "";
                }
                else if (tab === "Search") {
                    activeroute.tab = "Search";
                    activeroute.letrid = "";
                }
                else if (tab === "Home") {
                    activeroute.tab = "Home";
                }
                if (parts.length > 2) {
                    if (activeroute.tab == "Document") {
                        activeroute.objectid = parts[2];
                        if (parts.length > 3) {
                            activeroute.noteid = parts[3];
                        }
                    }
                    else if (activeroute.tab == "Datasheet") {
                        activeroute.datasheetid = parts[2];
                        if (parts.length > 3) {
                            activeroute.schemaid = parts[3];
                            if (parts.length > 4) {
                                activeroute.rowid = parts[4];
                            }
                        }
                    }
                }
            }
            this.activeroute = activeroute;
            if (this.initalroute === undefined) {
                this.initalroute = Object.assign({}, activeroute);
            }
        }
    }
    getInitialRoute() {
        return this.initalroute;
    }
    updateUrlHash() {
        if (!this.activeroute) {
            return;
        }
        let hash = "#" + this.activeroute.letrid;
        if (this.activeroute.tab === 'Document') {
            if (this.activeroute.objectid) {
                hash += "~~Doc~~" + this.activeroute.objectid;
                if (this.activeroute.noteid) {
                    hash += "~~" + this.activeroute.noteid;
                }
            }
        }
        else if (this.activeroute.tab === 'Datasheet') {
            if (this.activeroute.datasheetid) {
                hash += "~~Datasheet~~" + this.activeroute.datasheetid;
                if (this.activeroute.schemaid) {
                    hash += "~~" + this.activeroute.schemaid;
                    if (this.activeroute.rowid) {
                        hash += "~~" + this.activeroute.rowid;
                    }
                }
            }
        }
        else if (this.activeroute.tab === 'Admin') {
            hash += "~~Admin";
        }
        else if (this.activeroute.tab === 'Contacts') {
            hash += "~~Contacts";
        }
        else if (this.activeroute.tab === 'Devices') {
            hash += "~~Devices";
        }
        else if (this.activeroute.tab === 'Search') {
            hash += "~~Search";
        }
        else if (this.activeroute.tab === 'Home') {
            hash += "~~Home";
        }
        window.location.hash = hash;
    }
}
export const Router = new Store();
